import Vue from 'vue';
import Router from 'vue-router';
import Landing from '@/components/site/Landing';
import E0 from '@/components/site/e0';

Vue.use(Router);

export default new Router({
   routes: [
      {
         path: '/',
         name: 'Landing',
         component: Landing
      },
      {
         path: '/muktar',
         name: 'E0',
         component: E0
      },
      {
         path: '/mukhtar', 
         redirect: '/muktar'
      },
      {
         path: '*', 
         redirect: '/'
      }
   ],
   mode: 'history'
});



// WEBPACK FOOTER //
// ./src/router/index.js